import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import TabSection from '../components/TabSection';
import { SITE_URL } from '../config';

import Card from '../components/Card';
import DTC from '../assets/logos/DTC.svg';
import asignIconPrimary from '../assets/logos/asign-icon-primary.svg';
import image from '../assets/images/person-using-laptop.jpg';



function Overview({ activeSectionId, setActiveSectionId, setCurrentVideoUrl, setVideoSidebarOpen, setVideoLabels, setSelectedVideoIndex, setAllVideoUrls, registerSection, unregisterSection }) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const isFR = i18n.language === 'fr';
  const dtcPath = isFR ? '/fr/credit-impot-pour-personnes-handicapees' : '/disability-tax-credit';
  const cdbPath = isFR ? '/fr/prestation-canadienne-pour-les-personnes-handicapees' : '/canada-disability-benefit';

  return (
    <>
      <Helmet>
        <title>{isFR ? "Aperçu | deafinfo.ca/fr | ASC-CAD" : 'Overview | deafinfo.ca | CAD-ASC'}</title>
        <meta name="description" content="CAD-ASC provides resources and support for Canadians navigating disability benefits and tax credits." />
        <meta property="og:title" content={isFR ? "Aperçu | deafinfo.ca/fr | ASC-CAD" : 'Overview | deafinfo.ca | CAD-ASC'} />
        <meta property="og:description" content="CAD-ASC provides resources and support for Canadians navigating disability benefits and tax credits." />
        <meta property="og:image" content={`${SITE_URL}/CAD-ASC-meta-image.png`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={isFR ? "Aperçu | deafinfo.ca/fr | ASC-CAD" : 'Overview | deafinfo.ca | CAD-ASC'} />
        <meta name="twitter:description" content="CAD-ASC provides resources and support for Canadians navigating disability benefits and tax credits." />
        <meta name="twitter:image" content={`${SITE_URL}/CAD-ASC-meta-image.png`} />
      </Helmet>
          
         
      <section className="wrapper">

        {/* OVERVIEW SECTION */} 
        <section className="mb-5">
        <TabSection 
        videoUrls={["/ASL/DISC ASL Overview.mp4", "/LSQ/Aperçu.mp4"]} videoLabels={["ASL", "LSQ"]}
        sectionId="sections.overview"
        activeSectionId={activeSectionId} 
        setActiveSectionId={setActiveSectionId} 
        setCurrentVideoUrl={setCurrentVideoUrl} 
        setVideoSidebarOpen={setVideoSidebarOpen} 
        setVideoLabels={setVideoLabels} 
        setSelectedVideoIndex={setSelectedVideoIndex} 
        setAllVideoUrls={setAllVideoUrls} 
        isDefault 
        registerSection={registerSection}
        unregisterSection={unregisterSection}>

            <h1>{t('overview.page.overview-title')}</h1>
            <div className="flex gap-5 overview-section">
              <div className="section-copy">
                <p>
                  {t('overview.page.overview-description-part1')}
                  <Link to={dtcPath}>
                    {t('overview.page.overview-description-link1')}
                  </Link>
                  {t('overview.page.overview-description-part2')}
                  <Link to={cdbPath}>
                    {t('overview.page.overview-description-link2')}
                  </Link>
                  {t('overview.page.overview-description-part3')}
                </p>
              </div>
              <div className="section-media">
                <img className="overview-image" src={image} alt="Person using a laptop" />
              </div>
            </div>
          </TabSection>
        </section>

        {/* INTRODUCTION SECTION */}
        <section className="mb-5">
        <TabSection 
        videoUrls={["/ASL/DISC ASL Intro.mp4", "/LSQ/Introduction LSQ.mp4"]} videoLabels={["ASL", "LSQ"]}
        sectionId="sections.intro"
        activeSectionId={activeSectionId} 
        setActiveSectionId={setActiveSectionId} 
        setCurrentVideoUrl={setCurrentVideoUrl} 
        setVideoSidebarOpen={setVideoSidebarOpen} 
        setVideoLabels={setVideoLabels} 
        setSelectedVideoIndex={setSelectedVideoIndex} 
        setAllVideoUrls={setAllVideoUrls} 
        isDefault 
        registerSection={registerSection}
        unregisterSection={unregisterSection}>

            <h2>{t('overview.page.intro-title')}</h2>
            <div className="overview-section">
              <div className="section-copy">
                <p>
                  <Trans
                    i18nKey="overview.page.intro-description"
                    components={{
                      icon: (
                        <span
                          className="inline-asign-chip"
                          style={{ backgroundImage: `url(${asignIconPrimary})` }}
                          aria-hidden="true"
                        />
                      ),
                    }}
                  />
                </p>
              </div>
            </div>
          </TabSection>
        </section>


        {/* FORMS SECTION */}
        <TabSection 
        videoUrls={["/ASL/DISC ASL Available Forms.mp4", "/LSQ/Formulaires disponibles.mp4"]}
        videoLabels={["ASL", "LSQ"]}
        sectionId="sections.forms"
        activeSectionId={activeSectionId} 
        setActiveSectionId={setActiveSectionId} 
        setCurrentVideoUrl={setCurrentVideoUrl} 
        setVideoSidebarOpen={setVideoSidebarOpen} 
        setVideoLabels={setVideoLabels} 
        setSelectedVideoIndex={setSelectedVideoIndex} 
        setAllVideoUrls={setAllVideoUrls}
        registerSection={registerSection}
        unregisterSection={unregisterSection}>

            <div className="flex col gap-5">

              <div className="row ">
                <h2>{t('overview.page.forms-title')}</h2>
                <p style={{ paddingTop: '0.5rem' }}>{t('overview.page.forms-description')}</p>
              </div>

              <div className="cards-section row gap-3">
                <Card 
                title={t('forms.card.form1-name')} 
                icon={<img src={DTC} alt="DTC Icon" width="50" height="50" />}
                cardType="1"
                onClick={() => navigate(dtcPath)}
                >
                </Card>

                <Card 
                title={t('forms.card.form2-name')} 
                icon={<img src={DTC} alt="DTC Icon" width="50" height="50" />}
                cardType="1"
                onClick={() => navigate(cdbPath)}
                >
                </Card>
              </div>
          </div>
        </TabSection>
      </section>
    </>
  );
}

export default Overview;
